<template>
	<AndroidProductPicker
		:products="products"
		:show-terms="showTerms"
		:active="activeProduct"
		:theme="productsTheme"
		:product-component="productComponent"
		@select="setActiveProduct"
	/>
</template>

<script setup>
import { ref } from '@vue/reactivity'

import AndroidProductPicker from './AndroidProductPicker'
import { watch } from '@vue/runtime-core'

// eslint-disable-next-line no-undef
const emit = defineEmits(['change'])
// eslint-disable-next-line no-undef
const props = defineProps({
	products: {
		type: Array,
		required: true,
		default: () => []
	},
	showTerms: { type: Boolean, default: true },
	productsTheme: { type: String, default: '' },
	productComponent: { type: String, default: 'ProductInline' }
})

const activeProduct = ref(null)
const setActiveProduct = (product) => {
	activeProduct.value = product
	emit('change', product)
}

watch(
	() => props.products,
	() => {
		setActiveProduct(props.products.find((product) => product.preset))
	},
	{
		immediate: true
	}
)
</script>
